/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import TimelineHistory from '../../../../../../components/ui-elements/timeline/TimelineHistory';
import { Typography } from '@mui/material';
import { useState } from 'react';
import { getAllOrgHistory } from '../../../../../../store/reducers/organization/organizationAction';

const OrgHistory = ({ selectedOrg }) => {
    const [historyList, setHistoryList] = useState([]);
    const orgHistory = useSelector(state => state.organization.organizationHistory);
    const dispatch = useDispatch()
    useEffect(() => {
        dispatch(getAllOrgHistory({ "organizationID": selectedOrg.organizationID }))
    }, [dispatch, selectedOrg]);
    useEffect(() => {
        setHistoryList([])
        if (orgHistory?.length > 0) {
            orgHistory.forEach(element => {
                setHistoryList(item => [...item, {
                    ...element, Record: {
                        name: element.Record.organizationName,
                        details: element.Record.organizationDetails,
                        createdBy: element.Record.createdBy ?? "",
                        updatedBy: element.Record.updatedBy ?? "",
                    }
                }])
            });
        }
    }, [historyList, orgHistory]);
    return (
        <>
            <Typography variant="h3" align="center" color="success.light">Organization  History</Typography>
            <TimelineHistory items={historyList} />
        </>
    )

}


export default OrgHistory;